<template>
  <div>
    <b-button
      v-if="row"
      v-b-popover.hover.top="`Lembrete`"
      :variant="color"
      @click.prevent="$bvModal.show(`lembrete_btn_modal-${row.id}`)"
      size="sm"
      ><i class="fas fa-sticky-note"></i
    ></b-button>
    <modal
      size="md"
      :id="`lembrete_btn_modal-${row.id}`"
      form="lembreteForm"
      btn_save
      :title="`Lembrete`"
    >
      <lembrete
        @updated="updated"
        :parent_name="parent_name"
        :parent_id="row.id"
      />
    </modal>
  </div>
</template>
<script>
import Lembrete from "./Lembrete.vue";
export default {
  components: { Lembrete },
  props: {
    parent_name: { type: String, required: true },
    row: { type: Object, required: true },
  },
  data() {
    return {
      color: "outline-secondary",
    };
  },
  mounted() {
    if (
      this.row.lembrete &&
      !!this.row.lembrete.lembrete &&
      this.row.lembrete.lembrete.length > 0
    ) {
      this.color = "warning";
    }
  },
  methods: {
    updated(data) {
      if (data.lembrete && data.lembrete.lembrete) {
        this.color = "warning";
      } else {
        this.color = "outline-secondary";
      }

      this.$bvModal.hide(`lembrete_btn_modal-${this.row.id}`);
    },
  },
};
</script>
